(function () {
  'use strict';

  // Store currency for everything the auction app and Shopify return. The
  // approximate line below each price converts it for visitors who think in
  // the other currency.
  var CURRENCY = 'CAD';
  var APPROX_CURRENCY = 'USD';
  var RATE_URL = 'https://api.frankfurter.dev/v1/latest?base=' + CURRENCY + '&symbols=' + APPROX_CURRENCY;
  var RATE_CACHE_KEY = 'sta-fx-' + CURRENCY + '-' + APPROX_CURRENCY;
  var RATE_MAX_AGE_MS = 12 * 60 * 60 * 1000;

  var approxRate = null;

  function formatMoneyNumber(dollars, opts) {
    opts = opts || {};
    var v = Number(dollars);
    if (!isFinite(v)) v = 0;

    var maxFrac = opts.decimals;
    if (maxFrac === undefined) {
      maxFrac = Number.isInteger(v) ? 0 : 2;
    }

    return v.toLocaleString('en-US', {
      minimumFractionDigits: maxFrac > 0 ? 0 : 0,
      maximumFractionDigits: maxFrac,
    });
  }

  function approxText(dollars) {
    if (!approxRate) return '';
    var v = Number(dollars);
    if (!isFinite(v) || v <= 0) return '';
    return '\u2248 $' + Math.round(v * approxRate).toLocaleString('en-US') + ' ' + APPROX_CURRENCY;
  }

  // Free-form estimate text such as "$500 - $700": convert every number in it.
  function approxRangeText(text) {
    if (!approxRate) return '';
    var found = false;
    var out = String(text || '').replace(/\$?\s*(\d[\d,]*(?:\.\d+)?)/g, function (_, num) {
      var v = parseFloat(num.replace(/,/g, ''));
      if (!isFinite(v)) return _;
      found = true;
      return '$' + Math.round(v * approxRate).toLocaleString('en-US');
    });
    return found ? '\u2248 ' + out.trim() + ' ' + APPROX_CURRENCY : '';
  }

  function approxSlotHtml(dollars) {
    var v = Number(dollars);
    if (!isFinite(v)) return '';
    return '<span class="sta-money__approx" data-sta-approx="' + v + '">' + approxText(v) + '</span>';
  }

  // opts.approx === false skips the approximate line.
  function formatMoneyHtml(dollars, opts) {
    return (
      '<small>$</small>' +
      formatMoneyNumber(dollars, opts) +
      '<span class="sta-money__code"> ' + CURRENCY + '</span>' +
      (opts && opts.approx === false ? '' : approxSlotHtml(dollars))
    );
  }

  function formatMoneyPlain(dollars, opts) {
    return '$' + formatMoneyNumber(dollars, opts) + ' ' + CURRENCY;
  }

  function escapeHtml(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function normalizePriceEstimateText(raw) {
    var text = String(raw || '').trim();
    if (!text) return '';
    if (text.indexOf('$') === -1) text = '$' + text;
    return text;
  }

  function formatPriceEstimateValueHtml(raw) {
    var text = normalizePriceEstimateText(raw);
    if (!text) return '';
    // Staff sometimes type the currency into the estimate; show it as typed.
    if (/\b(usd|cad)\b/i.test(text)) {
      return '<span class="sta-price-estimate__value">' + escapeHtml(text) + '</span>';
    }
    return (
      '<span class="sta-price-estimate__value">' +
      escapeHtml(text) +
      '</span><span class="sta-money__code"> ' + CURRENCY + '</span>' +
      '<span class="sta-money__approx" data-sta-approx-range="' + escapeHtml(text) + '">' +
      escapeHtml(approxRangeText(text)) +
      '</span>'
    );
  }

  function formatPriceEstimateCardHtml(raw) {
    var valueHtml = formatPriceEstimateValueHtml(raw);
    if (!valueHtml) return '';
    return (
      '<div class="sta-price-estimate sta-price-estimate--card">' +
      '<div class="sta-price-estimate__title">Est price:</div>' +
      '<div class="sta-price-estimate__value-wrap">' +
      valueHtml +
      '</div></div>'
    );
  }

  function getPriceEstimateForProductId(productId) {
    if (productId == null || productId === '') return '';
    var id = String(productId).replace(/"/g, '');
    var li = document.querySelector('ul.urls-check-cards-products li[data-product-id="' + id + '"]');
    return li ? (li.getAttribute('data-price-estimate') || '').trim() : '';
  }

  function fillPriceEstimateSlot(slotEl, rawText) {
    if (!slotEl) return;
    var text = String(rawText || '').trim();
    if (!text) {
      slotEl.hidden = true;
      slotEl.innerHTML = '';
      return;
    }
    slotEl.hidden = false;
    slotEl.innerHTML = formatPriceEstimateCardHtml(text);
  }

  function applyPriceEstimateToCard(card, productId, rawTextOverride) {
    if (!card) return;
    var slot = card.querySelector('[data-price-estimate-slot]');
    if (!slot) return;
    var text = rawTextOverride != null ? String(rawTextOverride).trim() : '';
    if (!text && productId != null && productId !== '') {
      text = getPriceEstimateForProductId(productId);
    }
    fillPriceEstimateSlot(slot, text);
    var row = card.querySelector('.sta-product-card__info-row');
    if (row) {
      row.classList.toggle('sta-product-card__info-row--no-estimate', !text);
    }
  }

  function productIdFromAttrs(attrs, lotFallback) {
    if (lotFallback && lotFallback.productId) return lotFallback.productId;
    if (!attrs) return '';
    var raw = attrs.platform_product_id || attrs.product_id || '';
    if (window.staProductNumericId) return window.staProductNumericId(raw) || '';
    var s = String(raw || '');
    var m = /Product\/(\d+)/i.exec(s);
    if (m) return m[1];
    var n = parseInt(s, 10);
    return isFinite(n) ? String(n) : '';
  }

  function fillApproxSlots(root) {
    if (!approxRate) return;
    var slots = (root || document).querySelectorAll('.sta-money__approx');
    for (var i = 0; i < slots.length; i++) {
      var el = slots[i];
      var text = el.hasAttribute('data-sta-approx-range')
        ? approxRangeText(el.getAttribute('data-sta-approx-range'))
        : approxText(el.getAttribute('data-sta-approx'));
      // Only write on change, so the observer below doesn't feed itself.
      if (el.textContent !== text) el.textContent = text;
    }
  }

  function readCachedRate() {
    try {
      var cached = JSON.parse(localStorage.getItem(RATE_CACHE_KEY) || 'null');
      if (cached && cached.rate > 0 && Date.now() - cached.fetchedAt < RATE_MAX_AGE_MS) return cached.rate;
    } catch (e) {}
    return null;
  }

  function writeCachedRate(rate) {
    try {
      localStorage.setItem(RATE_CACHE_KEY, JSON.stringify({ rate: rate, fetchedAt: Date.now() }));
    } catch (e) {}
  }

  // Daily reference rate (European Central Bank, via Frankfurter). If it can't
  // be fetched the approximate lines stay empty and hidden.
  function loadApproxRate() {
    var cached = readCachedRate();
    if (cached) return Promise.resolve(cached);
    if (!window.fetch) return Promise.resolve(null);
    return fetch(RATE_URL)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var rate = data && data.rates && Number(data.rates[APPROX_CURRENCY]);
        if (!(rate > 0)) return null;
        writeCachedRate(rate);
        return rate;
      })
      .catch(function () { return null; });
  }

  function startApprox() {
    loadApproxRate().then(function (rate) {
      if (!rate) return;
      approxRate = rate;
      fillApproxSlots(document);
      // Prices rendered later (section reloads, live bid updates) arrive with
      // empty slots; fill them as they appear.
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          fillApproxSlots(document);
        });
      }).observe(document.body, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startApprox);
  } else {
    startApprox();
  }

  window.staMoneyCurrency = CURRENCY;
  window.staFormatMoney = formatMoneyHtml;
  window.staFormatMoneyPlain = formatMoneyPlain;
  window.staFormatMoneyFromCents = function (cents, opts) {
    return formatMoneyHtml(Number(cents) / 100, opts);
  };
  window.staSetMoneyEl = function (el, dollars, opts) {
    if (!el) return;
    el.innerHTML = formatMoneyHtml(dollars, opts);
  };
  window.staFormatPriceEstimateCardHtml = formatPriceEstimateCardHtml;
  window.staGetPriceEstimateForProductId = getPriceEstimateForProductId;
  window.staFillPriceEstimateSlot = fillPriceEstimateSlot;
  window.staApplyPriceEstimateToCard = applyPriceEstimateToCard;
  window.staProductIdFromAuctionAttrs = productIdFromAttrs;
})();
